
import apiHelpers from './apiHelpers.js';
import { mapCrudStoreGen } from '@/helpers/utils/storeHelpers.js';
let defaultForm = {
  calculateQtyAgainstOrdersToday: false,
  calculateQtyAgainstOpenConsolidatedOrders: false,
  name: '',
  code: '',
  wmsType: 2,
  irmsApiKey: '',
  irmsApiSecret: '',
  // irmsCustomerName: '',
  // irmsCustomerCode: '',
  irmsEnvUrl: '',
  irmsSubDomain: '',

  landmarkUsername: '',
  landmarkPass: ''
  // landmarkClientId: '',
};

let defaultFilters = {
  name: ''
};

let genedStore = mapCrudStoreGen(defaultForm, defaultFilters, apiHelpers);

export default {
  namespaced: true,

  state: () => ({
    ...genedStore.state
  }),

  mutations: {
    ...genedStore.mutations
  },

  getters: {
    ...genedStore.getters
  },

  actions: {
    ...genedStore.actions
  },
};
